import { z } from "zod/v4";

export const KlaviyoFlowWebhookRequestPathParamsSchema = z.object({
  shopId: z.string(),
});

export type KlaviyoFlowWebhookRequestPathParamsType = z.infer<
  typeof KlaviyoFlowWebhookRequestPathParamsSchema
>;
